var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"mdc-menu-item mdc-list-item",attrs:{"tabindex":_vm.disabled?'-1':'0',"aria-disabled":_vm.disabled,"role":"menuitem"}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }